import React from "react";
import RateCardsView from "../features/pricing/views/RateCardsView";

const PricingRateCardsPage = () => <RateCardsView />;

export default PricingRateCardsPage;
